const JSONLD = ({ children }) =>
  children && children[0] ? (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html:
          typeof children[0] === 'string'
            ? children[0]
            : JSON.stringify(children[0]),
      }}
    />
  ) : null;
export default JSONLD;



// WEBPACK FOOTER //
// ./components/jsonld/index.js